/* eslint-disable */ 
import requestListStore from '@/store/request/request-list-store';
import requestFormStore from '@/store/request/request-form-store';

export default {
  namespaced: true,

  modules: {
    list: requestListStore,
    form: requestFormStore
  },
};
